module.exports = __webpack_public_path__ + "static/media/ic_收起.9900b8ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_收起.svg
// module id = 343
// module chunks = 0